/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeNewPasswordRequiredRequest
 */
export interface ChallengeNewPasswordRequiredRequest {
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredRequest
     */
    session: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeNewPasswordRequiredRequest
     */
    newPassword: string;
}

/**
 * Check if a given object implements the ChallengeNewPasswordRequiredRequest interface.
 */
export function instanceOfChallengeNewPasswordRequiredRequest(value: object): value is ChallengeNewPasswordRequiredRequest {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('session' in value) || value['session'] === undefined) return false;
    if (!('newPassword' in value) || value['newPassword'] === undefined) return false;
    return true;
}

export function ChallengeNewPasswordRequiredRequestFromJSON(json: any): ChallengeNewPasswordRequiredRequest {
    return ChallengeNewPasswordRequiredRequestFromJSONTyped(json, false);
}

export function ChallengeNewPasswordRequiredRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeNewPasswordRequiredRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'session': json['session'],
        'newPassword': json['newPassword'],
    };
}

export function ChallengeNewPasswordRequiredRequestToJSON(json: any): ChallengeNewPasswordRequiredRequest {
    return ChallengeNewPasswordRequiredRequestToJSONTyped(json, false);
}

export function ChallengeNewPasswordRequiredRequestToJSONTyped(value?: ChallengeNewPasswordRequiredRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'session': value['session'],
        'newPassword': value['newPassword'],
    };
}

